<template>
    <div style="height: 600px; width: 100%">
        <l-map
            v-if="showMap"
            :zoom="zoom"
            :center="center"
            :options="mapOptions"
            style="height: 100%"
        >
            <l-tile-layer
                :url="url"
                :attribution="attribution"
            />
            <l-marker v-for="(parking, index) in parkings" :lat-lng="getCoords(parking.Latitude, parking.Longitude)" :key="index">
                <l-popup>
                    <div @click="innerClick">
                        <h2>{{parking.Name}}</h2>

                        <div v-show="showParagraph">
                            <b>{{parking.Address}}</b>
                            <p>{{parking.Description}}</p>
                        </div>
                        <el-button type="primary" icon="el-icon-check" @click="selectParking('http://' + parking.ServerAddress + ':10260')">Выбрать парковку</el-button>
                    </div>
                </l-popup>
            </l-marker>
        </l-map>
    </div>
</template>

<script>
import { latLng } from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup } from "vue2-leaflet";
import { Icon } from 'leaflet'

delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})

export default {
    name: "Example",
    components: {
        LMap,
        LTileLayer,
        LMarker,
        LPopup
    },
    data() {
        return {
            zoom: 11,
            center: latLng(55.7507, 37.6656), // moscow
            url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            showParagraph: true,
            mapOptions: {
                zoomSnap: 0.5
            },
            showMap: true,
            parkings: []
        };
    },
    methods: {
        innerClick() {
        },
        getCoords(latitude, longitude) {
            return latLng(latitude, longitude)
        },
        selectParking (val) {
            sessionStorage.setItem('selectedParking', val)
            location.reload()
        }
    },
    created () {
        this.parkings = JSON.parse(sessionStorage.getItem('parkings'))

        let selectedParking = sessionStorage.getItem('selectedParking')
        let parkingFound = this.parkings.find(x => 'http://' + x.ServerAddress + ':10260' === selectedParking)
        if (parkingFound) {
            this.center = this.getCoords(parkingFound.Latitude, parkingFound.Longitude)
        }
    }
}
</script>

<style scoped>

</style>
